var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{staticClass:"sticky-header",scopedSlots:_vm._u([{key:"options-bar",fn:function(){return [_c('CampaignDetailHeader',{staticClass:"max-w-6xl"})]},proxy:true}])}),_c('div',{staticClass:"overview"},[_c('router-view',{key:_vm.$route.params.id})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }